import { isNil } from 'lodash';

export default {
  isUserLoggedIn: (state: { user: any }) => !isNil(state.user),
  getDropdown: (state: { dropdownOptions: { [x: string]: any }; dropdownIndex: string | number }) => state.dropdownOptions[state.dropdownIndex],
};
